import React, { useState, PureComponent } from "react";
import { Link, NavLink } from "react-router-dom";
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import Action1 from "../assets/images/Action-1.png";
import { Button } from "react-bootstrap";
import Back from "../assets/images/arrow2.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Pagination from "react-js-pagination";
import { notificatioStatusAction, orderListAction } from "../redux/actions/productAction";
import { update } from "lodash";
import moment from "moment/moment";
import Action4 from "../assets/images/Action-4.png";
import { orderStatusAction } from "../redux/actions/orderAction";
import SoundSocket from "./socket-notification";

const initialState = {
  search: "",
  date: "",
  startDate:"",
  endDate:"",
  status: "",
  store: "",
  orderData: [],
  notifcationKey:"",
  repeat:""
};
const OrderDetails = () => {
  const [iState, updateState] = useState(initialState);
  const dispatch = useDispatch();
  const getActivePage = JSON.parse(localStorage.getItem("activePage"))

  const searchLocal = JSON.parse(localStorage.getItem("localSearch"))
  const searchStartDate = JSON.parse(localStorage.getItem("localstartDate"))
  const searchEndDate = JSON.parse(localStorage.getItem("localendDate"))
  const searchStatus = JSON.parse(localStorage.getItem("localendDate"))
  const { search, status, date, store, orderData, notifcationKey, startDate,endDate, repeat } = iState;
  const { orderListData } = useSelector((state) => state.product);
  const [activePage, updateActivePage] = useState(1);
  const [serialNo, updateSerialNo] = useState(10);
  const storeid = JSON.parse(localStorage.getItem("ownerLogin"))?._id;
  const finalData = JSON.parse(localStorage.getItem("finalData"));


  
useEffect(() => {
  // localStorage.setIt/em("activePage", JSON.stringify(1))
  //  setInterval(()=>{
    dispatch(orderListAction({search, startDate, endDate, status,page:getActivePage}));
    // updateState({...})
    //  },1000*10)
 
},[])


  useEffect(() => {
      if(orderListData?.total){
        if(orderListData?.total !== 0){
          localStorage.setItem("finalData", JSON.stringify(orderListData))
        } 
       }
      //  else if (orderListData?.length === 0 || orderListData === undefined){
      //   console.log("--------orderListData?.length === 0 >",)
      //   localStorage.setItem("finalData", JSON.stringify([]))
      //  }
      //  },1000*20)
   

  }, [orderListData]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    updateState({ ...iState, [name]: value });
  };
  const [flag ,setFlag] = useState(false)
  const filteredData = () => {
   setFlag(true)
    dispatch(orderListAction({ search, startDate,endDate, status, }));
    localStorage.setItem("localSearch",JSON.stringify(search) )
    localStorage.setItem("localstartDate",JSON.stringify(startDate) )
    localStorage.setItem("localendDate",JSON.stringify(endDate) )
    localStorage.setItem("localstatus",JSON.stringify(status) )
    if (orderListData?.length === 0 || orderListData === undefined){
       
        localStorage.setItem("finalData", JSON.stringify([]))
       }
  };

  // const handlePageChange = (pageNumber) => {
    
  //   let ser = pageNumber * 10;
  //   updateSerialNo(ser);
  //   updateActivePage(pageNumber);
  //   dispatch(orderListAction({  page:pageNumber}));
  // };

  const handlePageChange = (pageNumber) => {
    let ser = pageNumber * 10;
    updateSerialNo(ser);
    updateActivePage(pageNumber);
    localStorage.setItem("activePage", JSON.stringify(pageNumber))
    dispatch(orderListAction({  page:pageNumber}));
    updateState({
      ...iState,
      search: "",
      status: "",
      city: "",
    });
  };

  const handleRefresh = () => {
    updateState(initialState);
    updateActivePage(1)
    localStorage.setItem("activePage", JSON.stringify(1))
    dispatch(orderListAction());
  };


  const handleNotificationFun = (id,status) => {
    dispatch(notificatioStatusAction({orderId:id,status:status})).then((res) => {
        // console.log(res)
        dispatch(orderListAction({ store: storeid }));
    }).catch((err) => {
        console.log("errr-->", err)
    })
  }

  const changeOrderStatus = (status,_id) => {
    dispatch(orderStatusAction({orderId:_id,status})).then((res) => {
      if(status == "Preparing" || "Completed"){
        dispatch(orderListAction({ store: storeid }));
        updateState({...iState, status:""})
       }
    }).catch((err) => {
      console.log(err)
      // dispatch(orderListAction({ store: storeid }));
    }
     
    )
  }

  return (
    <div>
      <Header />
      <SideNav />
      {/* <SoundSocket page={activePage}/>/ */}
      <SoundSocket flag={flag}/>
      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
            <h4 class="Title">Order Management</h4>
            </div>
          </div>

          <div className="Small-Wrapper">
           <div class="FilterMain">
              <div class="form-group">
                <label>Search</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search..."
                  name="search"
                  value={search}
                  onChange={handleInput}
                />
              </div>
              <div class="form-group">
                <label> startDate</label>
                <input
                  type="date"
                  class="form-control"
                  name="startDate"
                  value={startDate}
                  onChange={handleInput}
                  disabled={status ?? startDate}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
              <div class="form-group">
                <label> To</label>
                <input type="date" class="form-control"  name="endDate"
                  value={endDate}
                  onChange={handleInput}
                  disabled={startDate==""}
                        min={moment(startDate).format("YYYY-MM-DD")} />
                  </div>
              <div class="form-group">
                <label>Order Status Filter</label>
                <select
                  class="form-control"
                  name="status"
                  value={status}
                  disabled={ startDate ?? status}
                  onChange={handleInput}
                >
                  <option value="">Select Status</option>
                  <option value="Received">Received</option>
                  <option value="Preparing"> Preparing</option>
                  <option value="Completed">Completed</option>
                  <option value="Not Picked">Not Picked</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>
              <div class="form-group ">
                <label>&nbsp;</label>
                <button onClick={filteredData} class="Button AddButton">
                  Apply
                </button>
                <button class="Button AddButton" onClick={handleRefresh}>
                  {" "}
                  <i className="fa fa-refresh"></i>{" "}
                </button>
              </div>
            </div>
            <div class="TableList">
              <table style={{ width: "120%" }}>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Date & Time of Order</th>
                    <th>Customer Name</th>
                    <th>Order Value</th>
                    <th>Discounted Price</th>
                    <th>Order Quantity</th>
                    <th>Mode of payment </th>
                    <th>Status</th>
                    <th>Notification Status</th>
                    <th>action</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {orderListData &&
                  orderListData?.result &&
                  orderListData?.result?.length > 0 ? (
                    <>
                      {orderListData?.result?.map((ele, index) => (
                        //   console.log(ele)

                        <tr>
                          <td>{ele?.orderNumber}</td>
                          <td>{ele?.createdAt?.split("T")[0]}</td>
                          <td>{ele?.userId?.fullName}</td>
                          <td>{ele?.paymentAmount}</td>
                          <td>{ele?.discountedAmount}</td>
                          <td>{ele?.orderData?.length}</td>
                          <td>{ele?.paymentMode}</td>
                          <td>
                            {ele?.status === "Received" ? <><button
                              onClick={() => changeOrderStatus("Preparing",ele?._id)}
                              className="StatusPending"
                            >
                              Accept
                            </button></> : <> 
                            {/* <span class="Orange">{ele?.status}</span> */}
                            {ele?.status === "Completed" ? <>
                            <span class="Orange">{ele?.status}</span>
                            </> :  ele?.status === "Not Picked" ? 
                             <span class="Orange">{ele?.status}</span>
                             : ele?.status === "Cancelled" ? 
                             <span class="Orange">{ele?.status}</span>
                             :
                             
                             <button
                             onClick={() => changeOrderStatus("Completed",ele?._id)}
                             className="StatusPending"
                           >
                             Complete
                           </button>
                             }
                           
                            </>
                            }
                           
                          </td>



                          <td>
                            {ele?.orderNotiEnabled === "Active" ? 
                            <>
                             <label className="Switch">
                            <input
                              type="checkbox"
                              checked={true}
                              onChange={() =>
                                handleNotificationFun(ele?._id, "Inactive")
                              }
                            />
                            <span className="slider"></span>
                          </label>
                            </>
                            : 
                            <>
                             <label className="Switch">
                              <input
                                type="checkbox"
                                checked={false}
                                onChange={() =>
                                    handleNotificationFun(ele?._id, "Active")
                                }
                              />
                              <span className="slider"></span>
                            </label>
                            </>
                            }
                         
                          </td>
                          <td>
                            <Link
                              to="/order-details"
                              state={ele?._id}
                              class="Blue"
                            >
                              <img src={Action1} />
                            </Link>
                          </td>
                         
                         
                        </tr>
                      ))}
                    </>
                  ) : (
                    <>
                       <h2 className="MainMessage">Data not Found !!!</h2>
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div class="Pagination">
              <p>
                {" "}
                Total records : <span> {finalData?.total}</span>
              </p>
              <ul>
                {finalData?.total && (
                   <Pagination
                   activePage={activePage}
                   itemsCountPerPage={10}
                   totalItemsCount={finalData?.total}
                  //  pageRangeDisplayed={5}
                   onChange={handlePageChange}
                   itemClass="page-item"
                   linkClass="page-link"
                 />
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrderDetails;











































































































































































// import React, { useState, PureComponent } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Modal from 'react-bootstrap/Modal';
// import Carousel from 'react-bootstrap/Carousel';
// import "../App.css";
// import Header from "./header";
// import SideNav from "./sidenav";
// import Action1 from "../assets/images/Action-1.png";
// import { Button } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { useEffect } from "react";
// import { getOrderList } from "../redux/actions/orderAction";
// const initialState = {
//     search: "",
//     page: "",
//     status: "",
//     errors: "",
//     loading: "",
// }

// const OrderManagement = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [iState, updateState] = useState(initialState);
//     const { search, page, status, errors, loading } = iState;
   
//     const { orderData } = useSelector((state) => state.order);
//       console.log("orderData.......>", orderData)

//     //   useEffect(()=>{},[])
//     useEffect(()=>{
//         dispatch(getOrderList())
//     },[])
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         updateState({
//             ...iState,
//             [name]: value,
//         });
//     };

//     // const handleSubmit = () => {
//     //     dispatch(getDashboard({ startDate, endDate, timeFrame }))
//     //     if (dashboardData.status === 200) {
           
//     //         toast.success(dashboardData.message, {
//     //             position: toast.POSITION.TOP_RIGHT,
//     //         });


//     //         // updateState({ ...iState, startDate, endDate, timeFrame });
//     //     } else {
//     //         // console.log("res....",res.status);
//     //         navigate("/");
//     //         toast.error(dashboardData.message, {
//     //             position: toast.POSITION.TOP_RIGHT,
//     //         });


//     //     }
//     // }

//     return (
//         <div>
//             <Header />
//             <SideNav />
//             <div class="WrapperArea">
//                 <div class="WrapperBox">
//                     <div class="TitleBox">
//                         <div>
//                             <h4 class="Title">Order Management</h4>
//                         </div>
//                     </div>
//                     <div className="Small-Wrapper">
//                         <div class="FilterMain">
//                             <div class="form-group">
//                                 <label>Search</label>
//                                 <input type="text" class="form-control" placeholder="Search..." name="search" value={search} onChange={handleChange}/>
//                             </div>
//                             <div class="form-group">
//                                 <label> From</label>
//                                 <input type="date" class="form-control" />
//                             </div>
//                             <div class="form-group">
//                                 <label> To</label>
//                                 <input type="date" class="form-control" />
//                             </div>
//                             <div class="form-group">
//                                 <label>Order Status Filter</label>
//                                 <select class="form-control">
//                                     <option>Select</option>
//                                     <option>Received</option>
//                                     <option> Preparing</option>
//                                     <option>Completed</option>
//                                 </select>
//                             </div>
//                             <div class="form-group ">
//                                 <label>&nbsp;</label>
//                                 <button class="Button AddButton d-inline">Apply</button>
//                                 <button class="Button AddButton d-inline"> <i className="fa fa-refresh"></i> </button>
//                             </div>
//                         </div>
//                         <div class="TableList">
//                             <table style={{ width: "105%" }}>
//                                 <thead>
//                                     <tr>
//                                         <th >Order  ID</th>
//                                         <th>Date & Time of Order</th>
//                                         <th>Customer  Name</th>
//                                         <th>Billing Price</th>
//                                         <th>Discounted Price</th>
//                                         <th>Order Quantity</th>
//                                         <th>Mode of payment </th>
//                                         <th>Status</th>
//                                         <th>action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr>
//                                         <td>VNU101</td>
//                                         <td>22 June 2022 at<br /> 3:00 PM</td>
//                                         <td>Simmi sharma</td>
//                                         <td>$3423</td>
//                                         <td>$3423</td>
//                                         <td>02</td>
//                                         <td>Stripe</td>
//                                         <td><span class="Orange">Completed</span></td>
//                                         <td>
//                                             <Link to="/order-details" class="Blue" >
//                                                 <img src={Action1} />
//                                             </Link>
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td>VNU101</td>
//                                         <td>22 June 2022 at<br /> 3:00 PM</td>
//                                         <td>Simmi sharma</td>
//                                         <td>$3423</td>
//                                         <td>$3423</td>
//                                         <td>02</td>
//                                         <td>Stripe</td>
//                                         <td><span class="Orange">Completed</span></td>
//                                         <td>
//                                             <Link to="/order-details" class="Blue" >
//                                                 <img src={Action1} />
//                                             </Link>
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td>VNU101</td>
//                                         <td>22 June 2022 at<br /> 3:00 PM</td>
//                                         <td>Simmi sharma</td>
//                                         <td>$3423</td>
//                                         <td>$3423</td>
//                                         <td>02</td>
//                                         <td>Stripe</td>
//                                         <td><span class="Orange">Completed</span></td>
//                                         <td>
//                                             <Link to="/order-details" class="Blue" >
//                                                 <img src={Action1} />
//                                             </Link>
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td>VNU101</td>
//                                         <td>22 June 2022 at<br /> 3:00 PM</td>
//                                         <td>Simmi sharma</td>
//                                         <td>$3423</td>
//                                         <td>$3423</td>
//                                         <td>02</td>
//                                         <td>Stripe</td>
//                                         <td><span class="StatusTable">
//                                             <div class="form-group">
//                                                 <select class="form-control">
//                                                     <option> Preparing</option>
//                                                     <option>Received</option>
//                                                     <option>Completed</option>
//                                                 </select>
//                                             </div>
//                                         </span></td>
//                                         <td>
//                                             <Link to="/order-details" class="Blue" >
//                                                 <img src={Action1} />
//                                             </Link>
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                         <div class="Pagination">
//                             <p> Total records : <span> 10</span></p>
//                             <ul>
//                                 <li><a href="javascript:void(0);"><i class="fa fa-angle-double-left"></i></a></li>
//                                 <li><a href="javascript:void(0);"><i class="fa fa-angle-left"></i></a></li>
//                                 <li class="active"><a href="javascript:void(0);">1</a></li>
//                                 <li><a href="javascript:void(0);">2</a></li>
//                                 <li><a href="javascript:void(0);">3</a></li>
//                                 <li><a href="javascript:void(0);"><i class="fa fa-angle-right"></i></a></li>
//                                 <li><a href="javascript:void(0);"><i class="fa fa-angle-double-right"></i></a></li>
//                             </ul>
//                         </div>

//                         {/* {
//                             productList?.data?.length > 0 ?
//                             productList?.data?.map((ele, index) => (
//                                <div></div>
//                             )):
//                             <>
//                             <h2 className="MainMessage">Data not Found !!!</h2>
//                             </>} */}
//                     </div>

//                 </div>
//             </div>

//         </div>

//     );
// }
// export default OrderManagement